import { when } from 'mobx';
import { MraidStore } from '../MraidStore';
import { sendCustomTrack } from 'common/js/TrackAnalyticsHelper';
import { isFeatureEnable } from 'common/js/features-enabling';

const SIZE_RATIO_THRESHOLD = 0.99;

interface EdgeToEdgeDectectionIssueHandlerProps {
  mraidStore: MraidStore;
}
export class EdgeToEdgeDectectionIssueHandler {
  mraidStore: MraidStore;

  constructor({ mraidStore }: EdgeToEdgeDectectionIssueHandlerProps) {
    this.mraidStore = mraidStore;

    when(
      () => this.mraidStore.isViewable,
      () => this.sendEdgeToEdgeIssueEvent()
    );
  }

  sendEdgeToEdgeIssueEvent() {
    const { width: maxWidth, height: maxHeight } = window.mraid.getMaxSize();
    const {
      width: screenWidth,
      height: screenHeight
    } = window.mraid.getScreenSize();
    const hasMraidSizeDiscrepancy =
      maxWidth / screenWidth < SIZE_RATIO_THRESHOLD ||
      maxHeight / screenHeight < SIZE_RATIO_THRESHOLD;
    if (isFeatureEnable('edgeToEdgeDetection') && hasMraidSizeDiscrepancy) {
      sendCustomTrack('android_edge_issue');
    }
  }
}
